import useGoToNavigation from "../../../../../util/useGotoNavigation";
import {AdjustmentUpdateType, InvHistoryType} from "../interface";
import React from "react";
import {useUser} from "../../../../../util/userContext/UserContext";
import {SubmitHandler, useForm, useWatch} from "react-hook-form";
import ScanBarcodeInner from "../../../../../components/common/modal/inner/ScanBarcodeInner";
import {useModal} from "../../../../../hooks";
import {useUploadAdjustmentExcel} from "../../../adjustment/create/hooks/useUploadAdjustmentExcel";
import FileUploadNoText from "../../../../../components/common/fileUpload/fileUploadNoText/FileUploadNoText";
import {useUpdateAdjustment} from "../hooks/useUpdateAdjustment";
import EmptyTableRow from "../../../../common/EmptyTableRow";

interface PropsType {
    inventoryChangeDetail: InvHistoryType
    btnToggleEdit: () => any;
}

export default function InvHistoryAdjustmentEdit({inventoryChangeDetail, btnToggleEdit}: PropsType) {
    const {handleModal} = useModal();
    const {goToNavigation} = useGoToNavigation()

    const {user} = useUser();
    const {mutateAsync: mutateAsyncUpdateAdjustment} = useUpdateAdjustment()
    const {mutateAsync: mutateAsyncUploadAdjustmentExcel} = useUploadAdjustmentExcel()

    const {register, handleSubmit, reset, getValues, control, setValue, watch} = useForm({
        defaultValues: inventoryChangeDetail,
    });

    const watchUpdateData = {
        ...inventoryChangeDetail,
        ...useWatch<InvHistoryType>({control}),
    };

    const onSubmit: SubmitHandler<InvHistoryType> = (submitData) => {
        if (getValues("inventoryChangeResList").length === 0) {
            handleModal({
                isOpen: true,
                contents: "품목을 추가해주세요.",
                type: "alert"
            })
        } else {
            const param: AdjustmentUpdateType = {
                memo: getValues("memo"),
                inventoryChangeRecordId: getValues("inventoryChangeRecordId"),
                updateEachAdjustmentReqList: getValues("inventoryChangeResList").map(el => ({
                    ...el,
                    changeAmount: el.newInventoryAmount
                })),
            }

            mutateAsyncUpdateAdjustment(param).then(res => {
                if (res.data.code === "0000") {
                    handleModal({
                        isOpen: true,
                        contents: "수정되었습니다.",
                        type: "alert",
                        closeAction: () => {
                            goToNavigation(`inventory/inv/history/${res.data.result?.inventoryChangeId}`, {}, false)
                            btnCancel()
                        }
                    });
                } else {
                    handleModal({
                        isOpen: true,
                        contents: res.data.msg,
                        type: "alert",
                    });
                }
            })
        }
    };

    const btnImportExcel = (file: File[]) => {
        if (file.length === 0) {
            handleModal({
                isOpen: true,
                contents: "파일을 선택해주세요.",
                type: "alert"
            })
        } else {
            const fd = new FormData()
            fd.append("excelFile", file.at(0) as File)

            mutateAsyncUploadAdjustmentExcel(fd).then((res: any) => {
                if (res.data.code === "0000") {
                    const list = res.data.result

                    if (
                        getValues("inventoryChangeResList").some(el => list.map((el2: any) => el2.inventoryId).includes(el.inventoryId))
                    ) {
                        handleModal({
                            isOpen: true,
                            contents: "중복된 품목은 추가할 수 없습니다.",
                            type: "alert",
                        });
                    } else {
                        setValue("inventoryChangeResList", [...getValues("inventoryChangeResList"), ...list.map((el: any) => ({
                            ...el,
                            changeAmount: 0
                        }))])
                    }
                } else {
                    handleModal({
                        isOpen: true,
                        contents: res.data.message ?? res.data.msg,
                        type: "alert",
                    });
                }
            })
        }
    }

    const btnShowScanBarcodeInterface = () => {
        handleModal({
            isOpen: true,
            contents: <ScanBarcodeInner
                value={getValues("inventoryChangeResList")}
                setValue={(data) => setValue("inventoryChangeResList", data)}
            />,
            type: "",
            title: "바코드 스캔"
        });
    }

    // const btnGoToList = () => {
    //     goToNavigation(-1, {}, false)
    // }

    const btnCancel = () => {
        reset()
        btnToggleEdit()
    }

    return <div className="content_wrap">
        <div className="fiter_top">
            <h3 className="filter_heading">조정 상세보기</h3>
            <div className="filter_toolbar">
                {/* NOTE: 목록 버튼이 필요 없어 보여서 삭제 */}
                {/*<button className="btn btn-outline-primary w-100px h-38px" onClick={btnGoToList}>*/}
                {/*    <img src={process.env.PUBLIC_URL + "/assets/images/icon_hamburger_btn.png"} alt=""/>목록*/}
                {/*</button>*/}
                <button className="btn btn-info w-100px h-38px" onClick={handleSubmit(onSubmit)}>저장
                </button>
                <button className="btn btn-outline-secondary w-100px h-38px"
                        onClick={btnCancel}>취소
                </button>
            </div>
        </div>

        <h5 className="subheading">조정 정보</h5>
        <table className="table table-bordered my_table">
            <tbody>
            <tr>
                <th style={{width: "16.66%"}}>조정번호</th>
                <td colSpan={3}>{inventoryChangeDetail.code}</td>
            </tr>
            <tr>
                <th style={{width: "16.66%"}}>생성자</th>
                <td style={{width: "33.3%"}}>{user?.userName ?? ""}</td>
                <th style={{width: "16.66%"}}>생성일자</th>
                <td>{inventoryChangeDetail.modAt}</td>
            </tr>
            <tr>
                <th>메모</th>
                <td className="p-4px" colSpan={3}>
                    <input type="text" className="form-control"
                           value={watchUpdateData.memo}
                           {...register("memo")}
                    />
                </td>
            </tr>
            </tbody>
        </table>

        <div className="table_top mb-10px align-items-end">
            <h6 className="table_stats">조정 품목</h6>
            <div className="table_toolbar">
                <FileUploadNoText
                    addFileCallback={(file: File[]) => btnImportExcel(file)}
                    customRenderer={(onClick: any, disabled: any) =>
                        <button className="btn btn-outline-dark w-150px px-0"
                                onClick={onClick}
                                disabled={disabled}><img
                            src={process.env.PUBLIC_URL + "/assets/images/icon_import.png"} alt=""/>엑셀 가져오기
                        </button>

                    }
                    accept={".xlsx, .xls"}
                />
                <button className="btn btn-primary w-100px px-0 ms-40px" onClick={btnShowScanBarcodeInterface}>바코드 스캔
                </button>
            </div>
        </div>

        <table className="table table-bordered my_table mb-0">
            <thead>
            <tr>
                <th style={{width: "10.06%"}}>벤더</th>
                <th style={{width: "10.06%"}}>카테고리</th>
                <th style={{width: "33.33%"}}>품목</th>
                <th style={{width: "13.83%"}}>규격</th>
                <th style={{width: "13.83%"}}>단위</th>
                <th>재고</th>
            </tr>
            </thead>
            <tbody>
            {watchUpdateData.inventoryChangeResList.length !== 0
                ? watchUpdateData.inventoryChangeResList.map((el, idx) =>
                    <tr>
                        <td className="text-center">{el.vendor}</td>
                        <td className="text-center">{el.category}</td>
                        <td className="text-center">{el.newTxtNmItem}</td>
                        <td className="text-center">{el.newTxtStndItem}</td>
                        <td className="text-center">{el.inventoryUnit}</td>
                        <td className="p-4px">
                            <div className="d-flex justify-content-center align-items-center">
                                <input type="text"
                                       className="form-control text-center w-100"
                                       value={el.initialInventoryAmount}
                                       disabled
                                />
                                <span className="mx-1">&gt;</span>
                                <input type="text"
                                       className="form-control text-center w-100"
                                       value={el.newInventoryAmount}
                                       {...register(`inventoryChangeResList.${idx}.newInventoryAmount`)}
                                />
                            </div>
                        </td>
                    </tr>
                )
                : <EmptyTableRow colSpan={6} msg={"조정 품목을 추가해주세요."}/>
            }
            <tr className="blue">
                <td className="text-center" colSpan={3}>품목 수</td>
                <td className="text-end">{watchUpdateData.inventoryChangeResList.length}</td>
                <td className="text-center">총 수량</td>
                <td className="text-end">
                    {isNaN(watchUpdateData.inventoryChangeResList.reduce((acc, cur) => acc + Number((cur.newInventoryAmount as number) - (cur.initialInventoryAmount as number)), 0))
                        ? <>-</>
                        : <>
                            {watchUpdateData.inventoryChangeResList.reduce((acc, cur) => acc + Number((cur.newInventoryAmount as number) - (cur.initialInventoryAmount as number)), 0) > 0 &&
                                <span className="required">+</span>}
                            {watchUpdateData.inventoryChangeResList.reduce((acc, cur) => acc + Number((cur.newInventoryAmount as number) - (cur.initialInventoryAmount as number)), 0)}
                        </>
                    }
                </td>
            </tr>
            </tbody>
        </table>
    </div>
}